@if (supervision.email(); as email) {
  <aside class="supervision-banner" aria-live="polite">
    <span>Supervisando la cuenta de: <strong>{{ email }}</strong></span>
    <button type="button" (click)="finish()">Finalizar supervisión</button>
  </aside>
}
